<template>
  <button type="button" @click="handleGetPoint" class="get-button btn-success">
    地点取得
  </button>
</template>

<script>
import { getLatLng } from '@/lib/location/use-location'

export default {
  data() {
    return {}
  },
  props: {
    address: {
      type: String,
      required: true,
    },
    index: {
      type: String,
      required: false,
    },
  },
  methods: {
    async handleGetPoint() {
      const address = await getLatLng(this.address)
      const index = this.index
      this.$emit('get-point', address, index)
    },
  },
}
</script>

<style lang="scss" scoped>
.get-button {
  max-width: 100px;
  width: 100%;
  margin-left: 20px;
  border-radius: 5px;
  border: none;
  font-weight: bold;
  color: #fff;
  transition: 0.3s;
  &:focus {
    outline: none;
  }
}
</style>
